// Site-wide external links / integration endpoints.
export const CALENDLY_URL = 'https://calendly.com/anjum-wayfwdstrategies/30min';
